
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_cqcqk_k56le_181",
  "wrapper": "awsui_wrapper_cqcqk_k56le_185",
  "elementWrapper": "awsui_elementWrapper_cqcqk_k56le_189",
  "markerWrapper": "awsui_markerWrapper_cqcqk_k56le_193",
  "placement-right": "awsui_placement-right_cqcqk_k56le_198",
  "placement-left": "awsui_placement-left_cqcqk_k56le_203",
  "inlineWrapper": "awsui_inlineWrapper_cqcqk_k56le_208"
};
  